<script>
import moment from "moment";
import { startCase, get } from 'lodash';
import { shippingCourierItems, shippingCourierItemsCargo } from "@/data/shippingInit";

export default {
    props: [
        "discount",
        'theme',
        'payload',
        'IsDisabled',
        "totalQuantity",
        "totalPrice",
        "price",
    ],
    components: {
        
    },
    data() {
        return {
          shippingCourierItemsCargo,
          moment,
          iconAlertRequirement: {
            classic: require('@/assets/icons/alert-circle-filled.svg'),
            tuktuk: require('@/assets/icons/TuktukTheme/alert-circle-pink-filled.svg'),
          },
          startCase,
          get,
        }
    },
    mounted() {
    },
    watch: {

    },
    methods: {
        clearDiscountCode(code){
            this.$emit('clearDiscountCode', code)
        },        
        applyDiscount(discount){
            this.$emit('applyDiscount',discount)
        },
        transactionTypeLabel(paymentType) {
          const transactionTypes = {
            cod: 'COD',
            non_cod: 'Non-COD',
          };

          return `${this.$t('coupon.onlyForTransactionPaymentType')} ${transactionTypes[paymentType] || ''}`;
        },
        courierType(shippingType) {
          if (shippingType in this.shippingCourierItemsCargo) return 'cargo'
          return 'regular'
        },
        courierLabel(courier) {
          return this.shippingItems[courier].label2;
        },
        getDiscountValue(discount) {
          return get(discount, 'discount_value');
        },
        getDiscountShippingType(discount) {
          const discountValue = this.getDiscountValue(discount);
          const shippingType = get(discountValue, 'applies_to.shipping_type');

          return shippingType;
        },
        getDiscountMinimumRequirementType(discount) {
          return get(discount, 'minimum_requirements.type')
        },
        getDiscountMinimumRequirementValue(discount) {
          return get(discount, 'minimum_requirements.value')
        },
        shouldDisplayRequirementMinimumAmount(requirementMinimumType, discount) {
          const minRequirementType = this.getDiscountMinimumRequirementType(discount);
          const minRequirementValue = this.getDiscountMinimumRequirementValue(discount);

          if (!minRequirementType || !minRequirementValue) {
            return false;
          }

          switch (requirementMinimumType) {
            case 'minimum_quantity':
              return this.totalQuantity < minRequirementValue;

            case 'minimum_purchase':
              return this.price < minRequirementValue;

            default:
              return false;
          }
        },
        shouldDisplayRequirementCourier(discount) {
          const shippingType = this.getDiscountShippingType(discount);
          if (shippingType && shippingType !== 'all') {
              if (shippingType !== this.payload.deliveryCourier) {
                return true;
              }
          }

          return false;
        },
        getDiscountPaymentType(discount) {
          return get(discount, "payment_type");
        },
        getDiscountProductType(discount) {
          return get(discount, "product_type");
        },
        shouldDisplayRequirementPaymentType(discount) {
          const paymentType = this.getDiscountPaymentType(discount);
          const productType = this.getDiscountProductType(discount);

          if (!paymentType || paymentType === "both" || productType === "digital") {
            return false;
          }

          const isCOD = this.payload.payment === "COD";

          return (
            (isCOD && paymentType !== "cod") || (!isCOD && paymentType === "cod")
          );
        },
        shouldDisplayRequirementInformation(discount) {
          return get(this.discount, 'is_exclusive') ||
            this.getDiscountPaymentType(discount) && this.shouldDisplayRequirementPaymentType(discount) ||
            this.getDiscountMinimumRequirementType(discount) ===  'minimum_purchase' && this.shouldDisplayRequirementMinimumAmount('minimum_purchase', discount) ||
            this.getDiscountMinimumRequirementType(discount) === 'minimum_quantity' && this.shouldDisplayRequirementMinimumAmount('minimum_quantity', discount) ||
            this.getDiscountValue(discount) && this.shouldDisplayRequirementCourier(discount)
          ;
        },
        buttonLabelApplyDiscount(discount) {
          const automaticDiscountCode = get(this.payload.automaticDiscount, 'code');
          if (automaticDiscountCode === discount.title) {
            return this.$t('coupon.automaticallyUsed');
          }
         
          return this.$t('coupon.ClaimCoupon');
        }
    },
    computed: {
    shippingItems() {
      return { ...shippingCourierItems, ...shippingCourierItemsCargo }
    },
    assets() {
      return {
        icon: {
          tuktuk: require('@/assets/icons/discount-circle-red.svg'),
          classic: require('@/assets/icons/discount-circle.svg'),
        },
        moneyOffProduct: {
          tuktuk: require('@/assets/images/illustrations/icon-illustration-coupon-item.svg'),
          classic: require('@/assets/images/illustrations/icon-illustration-coupon-item.svg'),
        },
        moneyOffOrder: {
          tuktuk: require('@/assets/images/illustrations/icon-illustration-coupon-order.svg'),
          classic: require('@/assets/images/illustrations/icon-illustration-coupon-order.svg'),
        },
        moneyOffShipping: {
          tuktuk: require('@/assets/images/illustrations/icon-illustration-coupon-shipping.svg'),
          classic: require('@/assets/images/illustrations/icon-illustration-coupon-shipping.svg'),
        },
        empty: {
          tuktuk: require('@/assets/images/empty-state/coupons-empty-red.svg'),
          classic: require('@/assets/images/empty-state/coupons-empty-green.svg'),
        }
      }
    },
    width() {
      return this.theme === 'classic' ? '578px' : '530px'
    }
  },
}
</script>

<template>
    <div class="coupon__item coupon__item__shipping fff-coupon-item">
      <div class="fff-main-coupon">
        <div class="flex items-center">
            <img :src="assets[discount.discount_type][theme || 'classic']" alt="O">
            <div class="coupon__item__divider"></div>
        </div>
        <div class="fff-description-coupon">
          <p class="coupon__item__name m-0">{{ discount.title }}</p>
          <template v-if="discount.discount_value.type === 'fixed'">
            <p class="coupon__item__code m-0">{{ $t('coupon.Discount') }} {{ 'RP'
              + Number(discount.discount_value.value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</p>
          </template>
          <template v-else>
            <p class="coupon__item__code m-0">{{ $t('coupon.Discount') }} {{ discount.discount_value.value ?
              discount.discount_value.value + "% " : "" }}</p>
          </template>
          <p class="coupon__item__description m-0">        
            {{ discount.end_date ?
              `Valid ${moment(discount.full_start_date).format('DD/MM/YYYY')} - ${moment(discount.full_end_date).format('DD/MM/YYYY')}` :
              '-'
            }} 
          </p>

          <div v-if="theme === 'tuktuk'" class="fff-button-tuktuk-mobile">
            <button :class="{'disabled':!IsDisabled}" :disabled="!IsDisabled" @click="applyDiscount(discount)"  v-if="!payload.discounts.find(selectedDiscount => selectedDiscount.code === discount.title)" class="fff-button-mobile w-100">{{ buttonLabelApplyDiscount(discount) }}</button>
            <button @click="clearDiscountCode(discount.title)" v-else class="fff-button-mobile border">{{$t('coupon.Wipe')}}</button>
          </div>

        </div>
        <div class="flex items-center fff-button-section">
          <button :class="{ 'disabled':!IsDisabled, tuktuk: theme === 'tuktuk'}" :disabled="!IsDisabled" @click="applyDiscount(discount)"  v-if="!payload.discounts.find(selectedDiscount => selectedDiscount.code === discount.title)" class="fff-button-coupon w-100">{{ buttonLabelApplyDiscount(discount) }}</button>
          <button @click="clearDiscountCode(discount.title)" v-else class="pp-button--border">{{$t('coupon.Wipe')}}</button>
        </div>
      </div>

      <div v-if="shouldDisplayRequirementInformation(discount)" class="fff-specific-requirement" :class="[theme]">
        <hr class="coupon-separator" :class="[theme]" />
        <div class="additional-requirement">
          <template v-if="discount.is_exclusive">
            <div class="item-requirement">
              <img class="info-requirement" :src="iconAlertRequirement[theme]" alt="O">
              <p class="description-requirement coupon__item__description" :class="[theme]">
                  {{ $t('coupon.exclusiveCoupon.informationUsage') }}
              </p>
            </div>
          </template>
          <template v-if="getDiscountPaymentType(discount) && shouldDisplayRequirementPaymentType(discount)">
            <div class="item-requirement">
              <img class="info-requirement" :src="iconAlertRequirement[theme]" alt="O">
              <p class="description-requirement coupon__item__description" :class="[theme]">
                {{ transactionTypeLabel(getDiscountPaymentType(discount)) }}
              </p>
            </div>
          </template>
          <template v-if="getDiscountMinimumRequirementType(discount) === 'minimum_purchase' && shouldDisplayRequirementMinimumAmount('minimum_purchase', discount)">
            <div class="item-requirement">
              <img class="info-requirement" :src="iconAlertRequirement[theme]" alt="O">
              <p class="description-requirement coupon__item__description" :class="[theme]">
                  {{ getDiscountMinimumRequirementValue(discount)
                      ? `${$t('coupon.minimumPurchase')}
                  ${Number(getDiscountMinimumRequirementValue(discount)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                      : $t('coupon.NoMinPurchaseRequirement')
                  }}
              </p>
            </div>
          </template>

          <template v-else-if="getDiscountMinimumRequirementType(discount) === 'minimum_quantity' && shouldDisplayRequirementMinimumAmount('minimum_quantity', discount)">
            <div class="item-requirement">
              <img class="info-requirement" :src="iconAlertRequirement[theme]" alt="O">
              <p class="description-requirement coupon__item__description" :class="[theme]">
                {{ getDiscountMinimumRequirementValue(discount)
                    ? `${$t('coupon.minimumPurchase')} ${getDiscountMinimumRequirementValue(discount).toString().replace(/\B(?=(\d{3})+(?!\d))/g,
                        ",")} items`
                    : $t('coupon.NoMinPurchaseRequirement')
                }}
              </p>
            </div>
          </template>

          <template v-else-if="getDiscountValue(discount) && shouldDisplayRequirementCourier(discount)">
            <div class="item-requirement">
              <img class="info-requirement" :src="iconAlertRequirement[theme]" alt="O">
              <p class="description-requirement coupon__item__description" :class="[theme]">
                <template v-if="courierType(getDiscountShippingType(discount)) === 'regular'">
                  {{ $t('coupon.onlyForCourier') }} {{ courierLabel(getDiscountShippingType(discount)) }}
                </template>
                <template v-if="courierType(getDiscountShippingType(discount)) === 'cargo'">
                  Gunakan ekspedisi cargo “{{ courierLabel(getDiscountShippingType(discount)) }}”
                </template>
              </p>
            </div>
          </template>
        </div>
      </div>

      <div class="fff-button-mobile-section" :class="[theme]">
        <button :class="{'disabled':!IsDisabled}" :disabled="!IsDisabled" @click="applyDiscount(discount)"  v-if="!payload.discounts.find(selectedDiscount => selectedDiscount.code === discount.title)" class="fff-button-mobile w-100">{{ buttonLabelApplyDiscount(discount) }}</button>
        <button @click="clearDiscountCode(discount.title)" v-else class="fff-button-mobile border">{{$t('coupon.Wipe')}}</button>
      </div>
    </div>
</template>


<style lang="scss" scoped>
[data-theme="tuktuk"] {
  .coupon-show-more {
    display: flex;
    justify-content: center;
    align-items: center;

    &[data-expanded=true] {
      button svg {
        transform: rotate(180deg);
      }
    }

    button {
      height: unset !important;
      padding: 0 !important;
      margin-top: 8px;
      border-radius: 0 !important;
      background: none !important;
      display: flex;
      align-items: center;
      gap: 4px;
      color: #F75656;
      font-size: 14px;
      font-weight: 500;
    }
  }

  h3 {
    font-family: TikTokDisplayMedium !important;
    font-weight: 600;
  }

  .coupon__item {
    background: #FEEBEB;
    border-radius: 16px;
    row-gap: 0 !important;

    @media screen and (max-width: 500px) {
      grid-template-columns: auto 1fr !important;
      grid-template-rows: auto auto;
      row-gap: 16px !important;
      padding: 16px !important;
    }

    &::before {
      content: '';
      position: absolute;
      top: -12px;
      left: 56px;
      display: block;
      height: 24px;
      width: 24px;
      border-radius: 48px;
      background: #FFF;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -12px;
      left: 56px;
      display: block;
      height: 24px;
      width: 24px;
      border-radius: 48px;
      background: #FFF;
    }

    &>div:first-child {
      grid-row: 1 / 3;
    }

    img {
      margin-right: 24px;
      height: 40px;
      width: 40px;
    }
    
    &__shipping__products {
      grid-column: 2 / 4;

      hr {
        border-color: #F75656;
      }
      span {
        color: #F53535 !important;
      }
      path {
        fill: #F53535 !important;
      }
    }
    
    &__divider {
      position: absolute;
      top: 50%;
      left: 56px;
      transform: translateY(-50%);
      height: 140px;
      margin: 0 10px;
      border-left: 4px dashed #FFF;
    }

    &__name {
      font-family: TikTokDisplayBold;
      margin-bottom: 4px;
      color: #203551;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;

      @media screen and (max-width: 500px) {
        margin-bottom: 0px;
      }
    }
    &__code {
      margin-bottom: 4px;
      color: #F53535;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;

      @media screen and (max-width: 500px) {
        font-size: 12px;
        margin-bottom: 0px;
        line-height: 18px;
      }
    }
    &__description {
      margin-bottom: 0px;
      color: #15171C;
      opacity: 0.4;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;

      @media screen and (max-width: 500px) {
        font-size: 12px;
        margin-bottom: 0px;
        line-height: 18px;
      }
    }
  }
  .pp-button {
    &--fill {
      background: #F75656;

      @media screen and (max-width: 500px) {
        width: 100% !important;
        grid-column: 2 / 3;
        display: none;
      }
    }
    &--border {
      color: #F75656;
      background: #fff;
      border: 1px solid #F75656 !important;

      @media screen and (max-width: 500px) {
        width: 100% !important;
        grid-column: 2 / 3;
      }
    }
  }
  &::v-deep {
    .vs-pagination {
      gap: 8px !important;

      &-content {
        gap: 8px !important;
      }

      &__button {
        color: #EB435B;
        background-color: #FFF;
        border-radius: 40px;
        border: 1px solid #E0E9F4;
        border-radius: 40px !important;
      }

      &__active {
        color: #FFF;
        background-color: #EB435B !important;
        box-shadow: 0px 10px 20px 0px #00136A40;
        border-radius: 40px !important;
      }

      &__arrow {
        background-color: #FFF;
        border: 1px solid #EB435B !important;
        border-radius: 40px !important;
        
        .vs-icon-arrow::before,
        .vs-icon-arrow::after {
          background-color: #EB435B !important;
        }

        &:disabled {
          opacity: 1 !important;
          border: 1px solid #E0E9F4 !important;
          
          .vs-icon-arrow::before,
          .vs-icon-arrow::after {
            background-color: #203551 !important;
          }
        }
      }
    }
  }
}
[data-theme="classic"] {
  .coupon-show-more {
    display: flex;
    justify-content: center;
    align-items: center;

    &[data-expanded=true] {
      button svg {
        transform: rotate(180deg);
      }
    }

    button {
      height: unset !important;
      padding: 0 !important;
      margin-top: 8px;
      border-radius: 0 !important;
      background: none !important;
      display: flex;
      align-items: center;
      gap: 4px;
      color: #14AD4D;
      font-size: 14px;
      font-weight: 700;
    };
  }

  .coupon__item {
    background: #FFF;
    border-radius: 8px;
    border: 1px solid #E0E9F4;

    @media screen and (max-width: 500px) {
      gap: 8px !important;
      grid-template-columns: auto 1fr !important;
      grid-template-rows: auto auto;
      padding: 12px !important;
    }

    img {
      height: 64px;
      width: 64px;
    }
    
    &__divider {
      display: none;
    }
    
    &__shipping__products {
      grid-column: 1 / 4;

      hr {
        border-color: #BFCEE0;
      }
      span {
        color: #9D6508 !important;
      }
      fill {
        fill: #9D6508 !important;
      }
    }

    &__name {
      margin-bottom: 4px;
      color: #203551;
      font-size: 20px;
      font-weight: 700;
      line-height: 28px;

      @media screen and (max-width: 500px) {
        margin-bottom: 0px;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
      }
    }
    &__code {
      margin-bottom: 4px;
      color: #14AD4D;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;

      @media screen and (max-width: 500px) {
        margin-bottom: 0px;
        font-size: 12px;
        line-height: 18px;
      }
    }
    &__description {
      margin-bottom: 0px;
      color: #15171C;
      opacity: 0.4;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;

      @media screen and (max-width: 500px) {
        margin-bottom: 0px;
        font-size: 12px;
        line-height: 18px;
      }
    }

  }
  .pp-button {
    &--fill {
      background: #3BBA6A;
      box-shadow: 0px 1px 2px 0px #0000001F;

      @media screen and (max-width: 500px) {
        width: 100% !important;
        grid-column: 1 / 3;
        display: none;
      }

      &.disabled {
        border-radius: 8px;
        border: 1px solid #F6F8FC !important;
        color: #6C7E95;
        background-color: #F6F8FC;
        cursor: not-allowed;
      }
    }
    &--border {
      color: #14AD4D;
      background: #fff;
      border: 1px solid #14AD4D !important;

      @media screen and (max-width: 500px) {
        width: 100% !important;
        grid-column: 1 / 3;
      }
    }
  }
  &::v-deep {
    .vs-pagination {
      gap: 8px !important;

      &-content {
        gap: 8px !important;
      }

      &__button {
        color: #14AD4D;
        background-color: #FFF;
        border-radius: 40px;
        border: 1px solid #E0E9F4;
        border-radius: 40px !important;
      }

      &__active {
        color: #FFF;
        background-color: #14AD4D !important;
        box-shadow: 0px 10px 20px 0px #00136A40;
        border-radius: 40px !important;
      }

      &__arrow {
        background-color: #FFF;
        border: 1px solid #14AD4D !important;
        border-radius: 40px !important;
        
        .vs-icon-arrow::before,
        .vs-icon-arrow::after {
          background-color: #14AD4D !important;
        }

        &:disabled {
          opacity: 1 !important;
          border: 1px solid #E0E9F4 !important;
          
          .vs-icon-arrow::before,
          .vs-icon-arrow::after {
            background-color: #203551 !important;
          }
        }
      }
    }
  }
}

.pp-modal-vuesax {
  &__header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 24px;

    h3 {
      font-size: 24px;
    }

    @media screen and (max-width: 500px) {
      padding: 16px 20px;

      h3 {
        font-size: 14px;
        font-weight: 600;
      }
    }
  }

  &__main {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    min-height: 570px;
    max-height: 570px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 12px;
      cursor: pointer;
    }
    &::-webkit-scrollbar-track {
      border-radius: 20px;
    }
    &::-webkit-scrollbar-thumb {
      background: #BFCEE0;
      border: 3px solid transparent;
      border-radius: 8px;
      background-clip: padding-box;  
    }

    @media screen and (max-width: 500px) {
      padding: 16px;
      gap: 16px;
    }

    .coupon__item {
      position: relative;
      flex-shrink: 0;
      display: grid;
      grid-template-columns: auto 1fr auto;
      gap: 16px;
      padding: 9px 16px;
      letter-spacing: -0.2px;
      overflow: hidden;

      &:not(:last-of-type) {
        margin-bottom: 8px;
      }

      &__shipping {
        grid-template-rows: auto auto;

        svg {
          flex-shrink: 0;
        }
      }

      &__valid {
        margin-bottom: 0px;
        opacity: 0.4;
        color: #15171C;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
    }

    .pp-button {
      &--fill {
        align-self: center;
        width: 114px;
        height: 32px !important;
        flex-shrink: 0;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        white-space: nowrap;
        letter-spacing: -0.2px;

        &.disabled {
          border-radius: 8px;
          border: 1px solid #F6F8FC !important;
          color: #6C7E95;
          background-color: #F6F8FC;
          cursor: not-allowed;
        }
      }
      &--border {
        align-self: center;
        width: 114px;
        height: 32px !important;
        flex-shrink: 0;
        background: #FFF;
        font-size: 14px;
        font-weight: 500;
        white-space: nowrap;
        letter-spacing: -0.2px;
        box-shadow: 0px 1px 2px 0px #0000001F;
      }
    }
  }

  .search-white {
    font-size: 14px;
    background: #ffffff;
    border-radius: 10px;
    padding: 10px 15px 10px 35px;
    background-image: url("/img/search.svg");
    background-position: 12px 12px;
    background-repeat: no-repeat;
    border: 1px solid #e7edf4;
    border-color: #E0E9F4 !important;
    box-shadow: 0px 1px 2px 0px #1018280D;
  }

  &::v-deep {
    .vs-dialog {
      min-width: 0 !important;
      height: 654px;
      border-radius: 16px !important;
      overflow: hidden;

      &__content {
        margin-bottom: 0 !important;
      }

      &__close {
        top: 24px !important;
        right: 24px !important;
        background-color: #F6F8FC !important;
        padding: 2px !important;

        @media screen and (max-width: 500px) {
          top: 16px !important;
          right: 20px !important;
        }

        i {
          width: 24px;
          height: 24px;

          &::before,
          &::after {
            top: 13px;
            right: 7px;
            background: #BFCEE0 !important;
            height: 1.5px !important;
          }
        }
      }
    }
  }
}

button {
  height: 40px;
  color: #FFF;
  border: none;
  border-radius: 8px;
  border-color: #14AD4D !important;
}

.flex-grow-1 {
  flex-grow: 1;
}

.fw-700 {
  font-weight: 700;
}

.fw-600 {
  font-weight: 600;
}

.fw-500 {
  font-weight: 500;
}

.fs-13 {
  font-size: 13px;
}

.fs-14 {
  font-size: 14px;
}

.fs-16 {
  font-size: 16px;
}

.gap-16 {
  gap: 16px;
}

.color-mute {
  color: #6C7E95
}

.flex-grow-1 {
  flex-grow: 1;
}

.coupon-separator {
  margin: 8px 0px;
  width: 100%;

  &.tuktuk {
    border: 1px dashed #F75656;
  }

  &.classic {
    border: 1px dashed #BFCEE0;
  }
}

.additional-requirement {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .item-requirement {
    display: flex;
    gap: 4px;
    align-items: start;

    .info-requirement {
      height: 16px !important;
      width: 16px !important;
      margin: 0px !important;
    }

    .description-requirement {
      font-size: 14px;
      font-weight: 400;
      opacity: 1;
      line-height: 16px;

      &.tuktuk {
        font-family: TikTokDisplayRegular;
        color: #F53535
      }

      &.classic {
        color: #9D6508;
      }
    }
  }
}

@mixin button-theme($theme) {
  @if $theme == "tuktuk" {
    background-color: #F75656;
    color: #fff;
    border-radius: 8px;
    width: 100%;

    &.border {
      color: #F75656;
      background: #fff;
      border: 1px solid #F75656 !important;
    }

    &.disabled {
      background-color: #F6F8FC;
      color: #6C7E95;
      border: 1px solid #F6F8FC !important;
      cursor: not-allowed;
    }
  } @else if $theme == "classic" {
    background-color: #3BBA6A;
    color: #fff;
    box-shadow: 0px 1px 2px 0px #0000001F;
    width: 100%;

    &.border {
      color: #14AD4D;
      background: #fff;
      border: 1px solid #14AD4D !important;
    }

    &.disabled {
      background-color: #E9ECEF;
      color: #6C757D;
      border: 1px solid #E9ECEF !important;
      cursor: not-allowed;
    }
  }
}

.fff-coupon-item {
  display: flex !important;
  flex-direction: column !important;
  gap: 0px !important;

  .fff-main-coupon {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;

    .fff-description-coupon {
      display: flex;
      flex-direction: column;
      flex: 1;
      word-break: break-all;
    }

    .fff-button-tuktuk-mobile {
      display: none;

      @media screen and (max-width: 500px) {
        display: flex;
        align-items: center;
        margin-top: 8px;
      }

      .fff-button-mobile {
        @include button-theme("tuktuk");
      }
    }

    .fff-button-section {
      display: inline-block;

      @media screen and (max-width: 500px) {
        display: none;
      }

      .fff-button-coupon {
        padding: 6px 16px;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
        letter-spacing: -0.28px;
        &:not(.tuktuk) {
          @include button-theme("classic");
        }
  
        &.tuktuk {
          @include button-theme("tuktuk");
        }
      }
    }

  }

  .fff-specific-requirement {
    &.tuktuk {
      margin-left: 66px;
    }

    @media screen and (max-width: 500px) {
      display: none;
    }
  }

  .fff-button-mobile-section {
    display: none;

    &.classic {
      @media screen and (max-width: 500px) {
        width: 100% !important;
        grid-column: 1 / 3;
        display: inline-block
      }
      .fff-button-mobile {
        @include button-theme("classic");
      }
    }

    &.tuktuk {
      .fff-button-mobile {
        @include button-theme("tuktuk");
      }
    }
  }
}
</style>